import { CUSTOM_FILTERS_REDUCER_KEYS as KEYS } from '../reducers/customFiltersReducerKeys'

export const getCustomFiltersMap = state => state.getIn([KEYS.REDUCER]).get(KEYS.BY_ID)
export const getCustomFilters = state => getCustomFiltersMap(state).toList()
export const getOrderedCustomFilters = state => getCustomFilters(state).sortBy(customFilter => customFilter.name)
